// extracted by mini-css-extract-plugin
module.exports = {"container":"TipsManagement_container_WkYxs","amount":"TipsManagement_amount_12RA1","question":"TipsManagement_question_3JZoy","content":"TipsManagement_content_32rcr"};